module.exports = __webpack_public_path__ + "img/Feature.9fed1ef4.jpg";